import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function TradingViewExtensionCard() {
  return (
    <Paper sx={{p: 3, mb: 3}}>
      <Typography variant="h6" gutterBottom>
        TradingView extension
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>
        Sign in from the <strong>extension popup</strong> (CoachPebble section) using the same Google or email account
        you use here. Replay trades are sent with a Firebase ID token so the backend can resolve your uid.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        One-time setup: in Firebase Console → Authentication → Settings → <strong>Authorized domains</strong>, add{' '}
        <code>chrome-extension://{'<your-extension-id>'}</code> (shown under <code>chrome://extensions</code> → Details
        for this extension). Without it, Google sign-in from the extension will fail.
      </Typography>
    </Paper>
  );
}
